import {$} from '../jquery-definition.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';
import 'flickity-as-nav-for';

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

$( '.carousel' ).each( function() {
	var $this = $( this );

	var imageCount = $this.find( '.carousel-cell' ).length;

	$this.addClass( 'cell-count-' + imageCount );
} );

var $mediaCarousel = $( '.media-carousel' );
$mediaCarousel.on( 'select.flickity', function( event, index ) {
	setTimeout( () => {
		const $this = $( this );
		const flkty = $this.data( 'flickity' );

		$this.find( '.carousel-cell' ).each( function() {
			const $this = $( this );
			let video = $this.find( 'video' ).get( 0 );

			if ( video ) {
				video.pause();
				video.currentTime = 0;
			}

			if ( video && $this.hasClass( 'is-selected' ) ) {
				video.play();
			}
		} );

		let headerStyle = $( flkty.selectedElement ).attr( 'data-header-style' );
		$( 'body' ).attr( 'data-header-style', headerStyle );
	}, 0 );
} );

$mediaCarousel.flickity( {
	bgLazyLoad: 2,
	pageDots: false,
	prevNextButtons: true,
	selectedAttraction: 0.01,
	friction: 0.2,
	wrapAround: true,
	autoPlay: 5000,
	pauseAutoPlayOnHover: false,
	arrowShape: 'M2,54.9l42.9,43c2.7,2.7,7.2,2.7,9.9,0.4c2.3-2.7,2.3-7.2,0-9.9L23.2,56.8h74.1V43.2H23.2l31.7-31.7c2.7-2.7,2.7-6.8,0-9.5c-2.7-2.7-6.8-2.7-9.5,0l-43,43C-0.7,48.2-0.7,52.2,2,54.9z',
} );

$( document ).keydown( function( e ) {
	if ( e.keyCode == 37 ) {
		$mediaCarousel.flickity( 'previous' );
	} else if ( e.keyCode == 39 ) {
		$mediaCarousel.flickity( 'next' );
	}
} );

$( '.carousel-nav.previous' ).on( 'click', function() {
	$mediaCarousel.flickity( 'previous' );
} );

$( '.carousel-nav.next' ).on( 'click', function() {
	$mediaCarousel.flickity( 'next' );
} );

$( 'body' ).attr( 'data-header-style', $mediaCarousel.find( '.carousel-cell:first' ).attr( 'data-header-style' ) );

if ( $( '.media-carousel' ).length ) {
	var $carouselStatus = $( '.carousel-status' );
	var flkty = $mediaCarousel.data( 'flickity' );

	function updateStatus() {
		var cellNumber = flkty.selectedIndex + 1;
		// $carouselStatus.text( cellNumber + '/' + flkty.slides.length );
	}

	updateStatus();
	$mediaCarousel.on( 'select.flickity', updateStatus );

	$( window ).resize( function() {
		setTimeout( function() {
			$mediaCarousel.flickity( 'reposition' );
		}, 100 );
	} );
}
